import React, { useMemo, useState } from "react";
import ModalVerifyPhoneCommon from "../ModalVerifyPhoneCommon";
import { useApp } from "../../contexts";
import { getCookie } from "../../utils/helper";
import { KEY_COOKIE } from "../../constants";

const VerifyPhone = () => {
  const { user } = useApp();
  const [isOpenModal, setIsOpenModal] = useState(true);

  const isVerifyPhoneStatus = useMemo(() => Boolean(user?.verify_phone_status ?? 0), [user]);

  const isUpdatedInformation = useMemo(() => Boolean(user?.dob && user?.gender && user?.name), [user]);
  
  const onUpdateInformation = () => {
    const sso_token = getCookie(KEY_COOKIE.AUTH_TOKEN_COOOKIE)?.access_token;
    const redirect_uri = encodeURIComponent(`${process.env.REACT_APP_SSO_BASE_HOME}`);
    let ssoURL = process.env.REACT_APP_SSO_PHONE_VERIFICATION_URL;
    if (isVerifyPhoneStatus && !isUpdatedInformation) {
      ssoURL = process.env.REACT_APP_SSO_PERSONAL_INFORMATION_URL;
    }
    const urlIframe = `${ssoURL}?access_token=${sso_token}&from=web-ams&redirect_uri=${redirect_uri}&lan=${user?.language}&country_code=${user?.country_code ?? ''}&display_name=${user?.name ?? ''}&gender=${user.gender ?? ''}&dob=${user?.dob ?? ''}`;
    setIsOpenModal(false);
    return window.location.replace(urlIframe);
  }

  return (
    <div>
      {isOpenModal && (!isVerifyPhoneStatus || !isUpdatedInformation) && !!user?.token && !!user?.id && (
        <ModalVerifyPhoneCommon onClose={() => setIsOpenModal(false)} onSubmit={onUpdateInformation} />
      )}
    </div>
  );
};

export default VerifyPhone;
